var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFullscreenOffBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13959",
    fill: "none",
    stroke: "#006e94",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27029",
    d: "M13.562 6.983v6.546H7.014"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27030",
    d: "M24.986 13.53H18.44V6.984"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27031",
    d: "M18.44 25.019v-6.546h6.546"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27032",
    d: "M7.014 18.473h6.548v6.546"
  }))));
}
export default SvgIcFullscreenOffBlue;